// export const DS_BASE_URL = "https://localhost:44375/" //DEV Local
export const DS_BASE_URL = "https://api.digmstools.com/" //SERVER

// Authentication
export const APP_BASE_URL = 'https://sem-internal-tools.digmstools.com'; // PROD URL
// export const APP_BASE_URL = 'https://stage.sem-internal-tools.digmstools.com'; // STAGE URL
export const APP_BASE_URL_DEV = "http://localhost:3000" // DEV URL